<template>
  <div class="wifi-connect-page">
    <!-- 标题与说明 -->
    <div class="title-section">
      <h1 class="main-title">连接2.4G Hz频段WIFI</h1>
      <p class="sub-desc">请仔细阅读以下内容</p>
    </div>

    <!-- 内容板块：确认WiFi频段 -->
    <section class="content-section">
      <h2 class="section-title">一、如何确认我的WIFI是2.4G Hz还是5G Hz？</h2>
      <p class="section-content">
		若你的电脑已经连接该WiFi，选择“WiFi--属性--网络频段”，查看对应WiFi频段是2.4GHz还是5GHz。
      </p>
    </section>

    <!-- 内容板块：找不到家里WiFi -->
    <section class="content-section">
      <h2 class="section-title">二、找不到家里的WiFi？</h2>
      <p class="section-content">
		若请确保路由器未设置隐藏WIFI ssid。已设置隐藏的路由器无法在列表中显示，请修改路由器设置后刷新列表。
      </p>
    </section>

    <!-- 内容板块：设置2.4G频段WiFi -->
    <section class="content-section">
      <h2 class="section-title">三、如何设置2.4G Hz 频段的WiFi？</h2>
      <p class="section-content">
        若你的路由器同时支持2.4GHz和5GHz的Wi-Fi，但在上个页面仅搜索到一个Wi-Fi名称，可参考以下步骤设置你的2.4GHz Wi-Fi。
      </p>
      <p class="section-content">
        进入路由器后台，找到“无线设置（Wireless）”页面（进入方法通常在路由器背面的标签上）。找到2.4GHz的设置页面，并设置Wi-Fi名称（SSID）为“XXX-2.4G”，保存设置。更名完成后，即可在手机的Wi-Fi搜索页面找到“XXX-2.4G”的Wi-Fi名称。
      </p>
      <p class="section-content">
        不同品牌路由器设置方法请咨询相应路由器厂商客服。
      </p>
    </section>

    <!-- 内容板块：检查路由器设置 -->
    <section class="content-section ">
      <h2 class="section-title">四、如何检查路由器设置？</h2>
      <p class="section-content">
        设备无法联网，可能是由于输入的Wi-Fi密码错误，或者路由器的某些设置不合适导致，可参考以下指引修改路由器设置：
      </p>
      <ol class="section-list">
        <li>请确保手机连接的是2.4GHz Wi-Fi，暂不支持连接5GHz Wi-Fi。</li>
        <li>请确保路由器Wi-Fi名称未使用中文或特殊字符，Wi-Fi密码不要有数字和字母以外的特殊字符。</li>
        <li>请在路由器设置中记录2.4GHz Wi-Fi的名称及密码，重新添加家电时，确保选择该Wi-Fi并正确输入密码。</li>
        <li>如果路由器设置了“访客模式”，请不要使用访客网络绑定设备。</li>
        <li>如果路由器设置了“白名单”，请将设备的MAC地址添加到白名单中。</li>
        <li>请确保路由器不需要二次验证，大部分公共场所的Wi-Fi，如酒店、商场等，连接Wi-Fi后需要再次输入账号、密码信息进行二次验证，请不要使用此类路由器添加设备。</li>
        <li>建议将路由器打开DHCP（动态主机配置协议）。</li>
        <li>建议将路由器无线网络的加密方式为“WPA2-PSK/WPA-PSK”，部分设备暂不支持“强混合加密（WPA3/WPA2）”、“超强加密（WPA3）”。</li>
      </ol>
    </section>

    <!-- 内容板块：找不到2.4G网络的解决方法（根据截图，标题显示不全，这里保留原结构） -->
    <section class="content-section">
      <h2 class="section-title">五、如果您找不到2.4GHz网络，最简单的方法是：</h2>
		<p class="section-content">
			<span style="color: #090415;">1.重启一下您的路由器。</span>
			在出厂状态下，2.4GHz和5GHz信号默认是分开的，并且使用路由器底部贴纸上印着的默认名称（例如 TP-LINK_2.4G_XXXX 和 TP-LINK_5G_XXXX）。用户自然就能看到并连接到一个清晰的2.4GHz网络。
			<span style="color: #FF3838;">注意：对于大多数现代主流路由器（如小米、华为、TP-LINK家用新品），正常重启（按电源键或用软件重启）是不会恢复出厂设置的，它会保留所有用户配置。只有长按Reset键才会彻底重置。 </span>
			
		</p>
		<p class="section-content">
			<span style="color: #090415;">2.直接致电您的网络运营商</span>
			（移动/联通/电信），告诉他们：‘我需要打开路由器的2.4GHz Wi-Fi信号用于智能家居设备配网’，客服会远程帮您设置。
		</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'WifiConnect'
}
</script>

<style scoped>
/* 页面整体样式 */
.wifi-connect-page {
  padding: 16px 28px 52px 28px;
  background-color: #fff;
  font-family: HarmonyOS Sans SC;
}

/* 标题区域 */
.title-section {
  margin-bottom: 24px;
}
.main-title {
  margin-bottom: 8px;
  font-size: 24px;
  font-weight: bold;
  color: #090415;
}
.sub-desc {
  font-size: 12px;
  color: #9696A0;
  
}

/* 内容板块通用样式 */
.content-section {
  margin-bottom: 24px;
}
.section-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 24px;
  color: #090415;
}
.section-content {
  font-size: 12px;
  line-height: 1.6;
  margin-bottom: 8px;
  color: #9696A0;
}

/* 列表样式 */
.section-list {
  font-size: 12px;
  line-height: 1.6;
  padding: 0px 12px;
  color: #9696A0;
}
.section-list li {
  /* margin-bottom: 6px; */
}
</style>